/**
 * `@central/ui` — design system.
 *
 * Os tokens vivem em `tokens.css` e o preset do Tailwind em
 * `tailwind-preset.cjs`; este módulo exporta só o que é TypeScript.
 */
export const BRAND = {
  lime: '#C8D93A',
  teal: '#2BBFCF',
  gradient: 'linear-gradient(135deg, #C8D93A 0%, #2BBFCF 100%)',
} as const;

export type ThemeMode = 'light' | 'dark' | 'system';

/** Resolve o tema efetivo, considerando a preferência do sistema. */
export function resolveTheme(mode: ThemeMode, prefersDark: boolean): 'light' | 'dark' {
  if (mode === 'system') return prefersDark ? 'dark' : 'light';
  return mode;
}
